var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.892A4.892 4.892 0 0 1 4.892 0h96.216A4.892 4.892 0 0 1 106 4.892v22.831a4.892 4.892 0 0 1-4.892 4.892H4.892A4.892 4.892 0 0 1 0 27.723V4.893z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.693 6.153c-.237.252-.376.64-.376 1.145v18.019c0 .504.14.893.376 1.144l.06.06 10.094-10.095v-.238L7.754 6.095l-.06.058z",
    fill: "#00D7FE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 12,
    width: 10,
    height: 8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m21.211 19.792-3.363-3.366v-.238l3.365-3.365 4.062 2.308c1.138.647 1.138 1.706 0 2.352l-3.986 2.265-.078.044z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.211 19.792-3.363-3.366v-.238l3.365-3.365 4.062 2.308c1.138.647 1.138 1.706 0 2.352l-3.986 2.265-.078.044z",
    fill: "url(#b)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 16,
    width: 15,
    height: 11
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m21.288 19.748-3.441-3.44L7.693 26.462c.376.397.996.446 1.694.05l11.901-6.764z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.288 19.748-3.44-3.44L7.692 26.462c.376.397.996.446 1.694.05l11.901-6.764z",
    fill: "url(#d)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 5,
    width: 15,
    height: 12
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.288 12.867 9.387 6.104c-.698-.396-1.318-.347-1.694.05l10.154 10.154 3.441-3.441z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.288 12.867 9.387 6.104c-.698-.396-1.318-.347-1.694.05l10.154 10.154 3.441-3.441z",
    fill: "url(#f)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.714 25.238h1.521V15.045h-1.521v10.193zm13.704-6.521-1.744 4.42h-.052l-1.81-4.42h-1.64l2.715 6.177-1.548 3.436h1.588l4.183-9.613h-1.692zm-8.628 5.364c-.5 0-1.194-.25-1.194-.866 0-.786.866-1.088 1.613-1.088.67 0 .983.144 1.39.34a1.844 1.844 0 0 1-1.81 1.614zm.183-5.587c-1.102 0-2.242.486-2.714 1.561l1.35.564c.289-.564.826-.748 1.39-.748.787 0 1.587.472 1.6 1.312v.104a3.365 3.365 0 0 0-1.587-.393c-1.455 0-2.938.8-2.938 2.295 0 1.364 1.194 2.243 2.531 2.243 1.024 0 1.587-.46 1.942-.997h.052v.786h1.468v-3.907c0-1.81-1.35-2.82-3.094-2.82zm-9.403 1.464h-2.164v-3.494h2.164c1.138 0 1.783.942 1.783 1.747 0 .79-.645 1.747-1.783 1.747zm-.04-4.913h-3.645v10.193h1.521v-3.861h2.125c1.686 0 3.344-1.222 3.344-3.166 0-1.945-1.658-3.166-3.344-3.166zm-19.879 9.037c-1.051 0-1.93-.88-1.93-2.088 0-1.221.879-2.115 1.93-2.115 1.038 0 1.852.894 1.852 2.115 0 1.208-.814 2.088-1.852 2.088zm1.747-4.794h-.053c-.341-.407-.998-.775-1.825-.775-1.735 0-3.324 1.523-3.324 3.481 0 1.944 1.59 3.455 3.324 3.455.827 0 1.484-.368 1.825-.789h.053v.5c0 1.327-.709 2.036-1.852 2.036-.933 0-1.511-.67-1.748-1.235l-1.326.552c.38.92 1.392 2.049 3.074 2.049 1.786 0 3.297-1.051 3.297-3.612v-6.227h-1.445v.565zm2.496 5.95h1.524V15.044h-1.524v10.194zm3.77-3.362c-.04-1.34 1.038-2.023 1.812-2.023.605 0 1.118.301 1.288.735l-3.1 1.288zm4.729-1.156c-.289-.775-1.17-2.207-2.969-2.207-1.786 0-3.27 1.405-3.27 3.468 0 1.944 1.47 3.468 3.44 3.468 1.59 0 2.51-.972 2.891-1.537l-1.182-.789c-.394.578-.933.96-1.708.96-.775 0-1.327-.355-1.682-1.051l4.637-1.918-.157-.394zM36.45 19.577v1.471h3.52c-.106.828-.381 1.432-.801 1.853-.513.512-1.314 1.076-2.72 1.076-2.167 0-3.862-1.747-3.862-3.914 0-2.168 1.695-3.915 3.863-3.915 1.169 0 2.022.46 2.653 1.052l1.038-1.038c-.88-.841-2.05-1.485-3.691-1.485-2.97 0-5.465 2.417-5.465 5.386 0 2.969 2.496 5.386 5.465 5.386 1.602 0 2.81-.525 3.756-1.511.972-.972 1.274-2.338 1.274-3.442 0-.341-.026-.656-.079-.919H36.45zm9.033 4.505c-1.05 0-1.957-.867-1.957-2.101 0-1.248.906-2.102 1.957-2.102 1.05 0 1.957.854 1.957 2.102 0 1.234-.907 2.101-1.957 2.101zm0-5.569c-1.918 0-3.481 1.458-3.481 3.468 0 1.996 1.563 3.468 3.481 3.468s3.481-1.472 3.481-3.468c0-2.01-1.563-3.468-3.48-3.468zm7.594 5.57c-1.051 0-1.958-.867-1.958-2.102 0-1.248.907-2.102 1.958-2.102 1.05 0 1.957.854 1.957 2.102 0 1.234-.906 2.101-1.957 2.101zm0-5.57c-1.918 0-3.481 1.458-3.481 3.468 0 1.996 1.563 3.468 3.48 3.468 1.919 0 3.482-1.472 3.482-3.468 0-2.01-1.563-3.468-3.481-3.468z",
    fill: "#FFFFFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.446 8.48v1.91a1.697 1.697 0 0 1-.308.322c-.141.117-.336.22-.584.308-.246.086-.564.129-.953.129-.318 0-.61-.055-.878-.165a1.98 1.98 0 0 1-.692-.487 2.284 2.284 0 0 1-.451-.781 3.232 3.232 0 0 1-.158-1.047v-.405c0-.39.045-.737.136-1.042a2.17 2.17 0 0 1 .409-.778c.179-.215.399-.377.659-.487a2.23 2.23 0 0 1 .896-.169c.399 0 .732.07 1 .208.27.136.48.325.63.566.153.242.251.516.294.824h-.692a1.449 1.449 0 0 0-.186-.516.996.996 0 0 0-.39-.372c-.17-.096-.389-.144-.656-.144-.241 0-.45.045-.627.133a1.154 1.154 0 0 0-.437.38 1.766 1.766 0 0 0-.258.598 3.473 3.473 0 0 0-.083.792v.412c0 .301.035.57.104.806.072.237.173.439.305.606a1.314 1.314 0 0 0 1.078.505 2.4 2.4 0 0 0 .599-.06 1.33 1.33 0 0 0 .358-.151 1.06 1.06 0 0 0 .197-.169V9.038H33.55V8.48h1.896zm4.241 2.035v.562h-2.763v-.562h2.763zM37.064 5.86v5.217h-.691V5.86h.691zm2.258 2.243v.563h-2.398v-.563h2.398zm.33-2.243v.566h-2.728V5.86h2.727zm2.67 0v5.217h-.68V5.86h.68zm1.678 0v.566h-4.032V5.86H44zm2.752 0v5.217h-.692V5.86h.692zm2.858 0v5.217h-.681V5.86h.68zm1.677 0v.566h-4.031V5.86h4.03zm6.027 2.444v.33c0 .391-.049.742-.147 1.053-.098.31-.239.574-.423.792a1.833 1.833 0 0 1-.663.498 2.078 2.078 0 0 1-.86.172c-.308 0-.59-.057-.849-.172a1.908 1.908 0 0 1-.666-.498 2.318 2.318 0 0 1-.434-.792 3.347 3.347 0 0 1-.154-1.054v-.33c0-.391.05-.741.15-1.05.103-.31.248-.574.434-.791.187-.22.408-.387.663-.502a2.08 2.08 0 0 1 .85-.172c.317 0 .604.058.86.172.257.115.478.282.662.502.187.217.329.481.427.792.1.308.15.658.15 1.05zm-.684.33v-.337c0-.311-.033-.586-.097-.825a1.707 1.707 0 0 0-.276-.602 1.19 1.19 0 0 0-.448-.369 1.36 1.36 0 0 0-.595-.125c-.215 0-.41.042-.584.125-.172.084-.32.207-.444.37a1.805 1.805 0 0 0-.283.601c-.067.24-.1.514-.1.825v.336c0 .313.033.59.1.832.067.239.162.44.287.605.126.163.276.286.448.37.174.083.369.125.584.125.224 0 .424-.042.598-.126.174-.083.321-.206.44-.369.123-.165.215-.366.277-.605.062-.242.093-.519.093-.832zm5.513-2.774v5.217h-.695L58.82 7.053v4.024h-.691V5.86h.691l2.637 4.035V5.86h.685z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 24.534,
    y1: 16.308,
    x2: 17.848,
    y2: 16.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDA03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 19.418,
    y1: 19.545,
    x2: 10.691,
    y2: 26.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E22652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 9.231,
    y1: 7.376,
    x2: 15.05,
    y2: 12.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ED574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.106ac241371665433f21394e09206810.svg";
export { ForwardRef as ReactComponent };